import React from 'react';
import { CloseIcon } from './Icons';

const Modal = ({ isOpen, onClose, title, children, width = '500px', fullHeight = false, hideCloseButton = false, preventOutsideClick = false }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (preventOutsideClick) return;
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div 
        className={`modal-container ${fullHeight ? 'full-height' : ''}`}
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: width }}
      >
        {title && (
          <div className="modal-header">
            <h2>{title}</h2>
            {!hideCloseButton && (
              <button className="modal-close" onClick={onClose}>
                <CloseIcon size={16} />
              </button>
            )}
          </div>
        )}
        {!title && !hideCloseButton && (
          <button className="modal-close" onClick={onClose}>
            <CloseIcon size={16} />
          </button>
        )}
        <div className="modal-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal; 